const media = {
  mobile: '480px',
  tablet: '768px',
  laptop: '1100px',
};

const theme = {
  mobile: `(max-width: ${media.mobile})`,
  tablet: `(max-width: ${media.tablet})`,
  laptop: `(max-width: ${media.laptop})`,
};

export default theme;
